<template lang="pug">

  button(
    @click="onClick" 
    :disabled='isSelected' 
    :aria-label="ariaCopy" 
    :class="{ 'selected' : isSelected }"
    @focus="onMouseEnter"
    @mouseenter="onMouseEnter"
    @blur="onMouseLeave"
    @mouseleave="onMouseLeave"
    ).star-btn
    .dot(ref="dot")

</template>

<script>

import { mapState, mapMutations } from 'vuex'
import { MODAL_STATES, EVENTS } from 'src/config/app'
import gsap from 'gsap'
import Communicator from '@/helpers/Communicator'

export default {

  props: {
    star_index: Number
  },

  data() {
    return {
      ariaOptions: [
        'home-aria-label-star-five-button',
        'home-aria-label-star-four-button',
        'home-aria-label-star-three-button',
        'home-aria-label-star-two-button',
        'home-aria-label-star-one-button',
      ] 
    }
  },

  mounted(){ },

  computed: {
    ...mapState('app', [
      'home',
      'motion_clamp'
    ]),

    ariaCopy(){
      return this.lang_en[this.ariaOptions[this.star_index-1]]
    },

    isSelected(){
      return (this.star_index === this.home.section_index)
    } 
  },

  methods: {

    onClick(){
      this.$emit('navigate', this.star_index)
    },

    onMouseEnter(){
      gsap.killTweensOf([this.$refs.dot])
      gsap.to(this.$refs.dot, {
        scale: 2, 
        transformOrigin: '50% 50%',  
        duration: 0
      })
      Communicator.trigger(EVENTS.MOUSE_ENTER)
    },

    onMouseLeave(){
      if(this.star_index !== this.home.section_index){
        gsap.killTweensOf([this.$refs.dot])
        gsap.to(this.$refs.dot, {
          scale: 0.5, 
          transformOrigin: '50% 50%',  
          duration: 0.3 * this.motion_clamp
        })
        Communicator.trigger(EVENTS.MOUSE_LEAVE)
      } 
    },

    enter( delay ){
      gsap.killTweensOf([this.$refs.dot, this.$el]) 
      gsap.set(this.$refs.dot, { scale: 0, transformOrigin: '50% 50%' })
      gsap.to(this.$el, {
        opacity: 1, 
        duration: ( 0.5 * this.motion_clamp ),
        delay: ( delay * this.motion_clamp )
      })
      this.update(delay)
    },

    leave( ){
      gsap.killTweensOf([this.$refs.dot, this.$el])
      gsap.set(this.$el, {opacity: 0 })
      gsap.set(this.$refs.dot, { scale: 0, transformOrigin: '50% 50%' })
    },

    update(delay){
     gsap.killTweensOf( this.$refs.dot )
      let tgscale = (this.star_index === this.home.section_index) ? 1.5 : 0.5
      gsap.to(this.$refs.dot, {
        scale: tgscale, 
        transformOrigin: '50% 50%', 
        ease: 'back.out(5)', 
        duration: ( 1 * this.motion_clamp ),
        delay: (1 + delay) * this.motion_clamp
      })
    },

    updateSelected(){ 
      this.update(0)
    }
  },

  watch: { 
    'home.section_index': { 
      handler(val, prev) {
        this.updateSelected()
      }
    } 
  }

}

</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

.star-btn

  width: 30px
  height: 30px
  position: relative
  opacity: 0
  display: flex
  align-items: center
  justify-content: center
  outline: none

  &:disabled
    cursor: default

  @media all and (max-width: $bp-mobile)
    margin: 1rem 0

  .dot
    position: relative
    width: 8px
    height: 8px
    opacity: 1
    border-radius: 50%
    overflow: hidden
    background: #FFFFFF
    margin: 0.2rem 0

  &.selected

    .dot
      background: #FFD730




</style>
